interface UmamiWindow extends Window {
  umami?: {
    identify: (id: string) => void;
  };
}

export class UmamiService {
  static identify(uniqueId: string) {
    const win = window as UmamiWindow;
    if (win.umami) {
      win.umami.identify(uniqueId);
    }
  }
}
